function toggleTabsHandler() {
    const tabsWrapper = document.querySelector(".center-about");
    if (!tabsWrapper) return;

    const tabItems = tabsWrapper.querySelectorAll(".tabs-heading .tab-nav-item ");
    const tabContentWrapper = tabsWrapper.querySelector(".tabs-description");

    tabItems.forEach((tabItem) => {
        const content = tabItem.querySelector(".tab-content-item");

        if (content && tabContentWrapper) {
            tabContentWrapper.appendChild(content);
        }
    });

    const tabContentItems = tabsWrapper.querySelectorAll(".tabs-description > div");

    tabItems.forEach((tabItem) => {

        tabItem.addEventListener("click", function (e) {
            e.preventDefault();

            const index = this.getAttribute("data-index");

            tabItems.forEach((item) => item.classList.remove("active", "active-item"));
            tabContentItems.forEach((content) => content.classList.remove("active"));

            this.classList.add("active-item");
            const activeContent = tabsWrapper.querySelector(`.tabs-description [data-index="${index}"]`);
            if (activeContent) {
                activeContent.classList.add("active");
            }
        });
    });
}

toggleTabsHandler();